
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/wz/Brand';
import Expert from '@/pages/wz/expert';
import Guahao from '@/pages/wz/guahao';
import Apphome from '@/pages/app/apphome';
import Agree from '@/pages/app/agreement';

Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/',
            name: 'default',
            redirect: '/wz/home'
        },
        {
            path: '/wz/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/wz/expert',
            name: 'Expert',
            component: Expert
        },
        {
            path: '/wz/guahao',
            name: 'Guahao',
            component: Guahao
        },
        {
            path: '/app/home',
            name: 'appdownload',
            component: Apphome
        },
        {
            path: '/app/agree',
            name: 'agreement',
            component: Agree
        }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js